import { render, staticRenderFns } from "./teethView.vue?vue&type=template&id=6ae051b8&scoped=true"
import script from "./teethView.vue?vue&type=script&lang=js"
export * from "./teethView.vue?vue&type=script&lang=js"
import style0 from "./teethView.vue?vue&type=style&index=0&id=6ae051b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae051b8",
  null
  
)

export default component.exports